import { render, staticRenderFns } from "./distributionWithdrawDeposit.vue?vue&type=template&id=5d6df4e6&scoped=true&"
import script from "./distributionWithdrawDeposit.vue?vue&type=script&lang=js&"
export * from "./distributionWithdrawDeposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6df4e6",
  null
  
)

component.options.__file = "distributionWithdrawDeposit.vue"
export default component.exports